module.exports = "/images/backgroundWhiteWrongTrade.jpg";